<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBPaymentWayForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBPaymentWayList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPaymentWayForm from './Form.vue'

export default {
  components: {
    EXSBPaymentWayForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbpaymentway/update/isLoading',
      error: 'exsbpaymentway/update/error',
      deleteError: 'exsbpaymentway/del/error',
      deleteLoading: 'exsbpaymentway/del/isLoading',
      created: 'exsbpaymentway/create/created',
      deleted: 'exsbpaymentway/del/deleted',
      retrieved: 'exsbpaymentway/update/retrieved',
      updated: 'exsbpaymentway/update/updated',
      violations: 'exsbpaymentway/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPaymentWayList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbpaymentway/create/reset',
      deleteItem: 'exsbpaymentway/del/del',
      delReset: 'exsbpaymentway/del/reset',
      retrieve: 'exsbpaymentway/update/retrieve',
      updateReset: 'exsbpaymentway/update/reset',
      update: 'exsbpaymentway/update/update',
      updateRetrieved: 'exsbpaymentway/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbpaymentway ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
